import { render, staticRenderFns } from "./settings-password-update-form.vue?vue&type=template&id=e24e1fa0&scoped=true&"
import script from "./settings-password-update-form.vue?vue&type=script&lang=js&"
export * from "./settings-password-update-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e24e1fa0",
  null
  
)

export default component.exports